import styled from 'styled-components';

export const TransparentInput = styled.input`
  font-family: Poppins-Regular;
  font-size: 20px;
  line-height: 30px;
  border: 0px;
  width: 100%;
  outline: none;
`;

export const InputWrapper = styled.div`
  border: 1.28px solid #cdcdcd;
  box-sizing: border-box;
  border-radius: 30.72px;
  padding: 5px 3px 5px 10px;
  display: flex;
  flex-direction: row;
  width: 60%;
  cursor: pointer;
  z-index: 999;
  position: relative;

  @media screen and (max-width: 767px) {
    width: 100%;
  }
`;

export const InputButton = styled.div`
  background: #CF1625;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items:  center;
  min-height: 45px;
  min-width: 45px;
  cursor: pointer;
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.15);

  &:hover {
    opacity: 0.7;
  }
`;

export const ErrorMsg = styled.div`
  color: #CF1625;
  font-family: Poppins-Regular;
  font-size: 12px;
  line-height: 30px;
  margin-left: 10px;
`;

export const ButtonImg = styled.img`
  width: 21px;
`;